__turbopack_context__.v({
  "avatar": "TestimonialCardV2-module-scss-module__f8GQlG__avatar",
  "card": "TestimonialCardV2-module-scss-module__f8GQlG__card",
  "footer": "TestimonialCardV2-module-scss-module__f8GQlG__footer",
  "hpv2Blink": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2Blink",
  "hpv2DemoBounce": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2DemoBounce",
  "hpv2DemoFadeIn": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2DemoFadeIn",
  "hpv2DemoProgress": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2DemoProgress",
  "hpv2DemoScaleIn": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2DemoSlideIn",
  "hpv2FadeLeft": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2FadeLeft",
  "hpv2FadeRight": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2FadeRight",
  "hpv2FadeUp": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2FadeUp",
  "hpv2FloatA": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2FloatA",
  "hpv2FloatB": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2FloatB",
  "hpv2HeroFadeIn": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2PriceShimmer",
  "hpv2PulseDot": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2PulseDot",
  "hpv2ScaleUp": "TestimonialCardV2-module-scss-module__f8GQlG__hpv2ScaleUp",
  "meta": "TestimonialCardV2-module-scss-module__f8GQlG__meta",
  "name": "TestimonialCardV2-module-scss-module__f8GQlG__name",
  "quote": "TestimonialCardV2-module-scss-module__f8GQlG__quote",
  "role": "TestimonialCardV2-module-scss-module__f8GQlG__role",
  "starIcon": "TestimonialCardV2-module-scss-module__f8GQlG__starIcon",
  "stars": "TestimonialCardV2-module-scss-module__f8GQlG__stars",
});
